import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupDoctor = () => {
  //page hook
  const { t } = useTranslation();
  return {
    name: Yup.string().required(
      t("validation.required", {
        name: t("page.clinicName"),
      })
    ),
    phoneNumber: Yup.string().required(
      t("validation.required", {
        phoneNumber: t("page.phoneNumber"),
      })
    ),
  };
};
